import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { logger } from '../../../core/utils/console';

@Component({
    selector: 'app-editar-consulta',
    templateUrl: './editar-consulta.component.html',
    styleUrls: ['./editar-consulta.component.scss']
})
export class EditarConsultaComponent implements OnInit {

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        public dialogRef: MatDialogRef<EditarConsultaComponent>
    ) { }

    ngOnInit() {
        logger.log(this.data);
    }

    Alterar() {
        logger.log('Alterando a consulta');
    }

    Cancelar() {
        this.dialogRef.close(false);
    }

}
